var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName(_vm.tagSpec(_vm.tagSpecs, 0)),{tag:"component",class:_vm.tagClasses(_vm.tagSpec(_vm.tagSpecs, 0))},[_vm._v(_vm._s(_vm._f("time")(_vm.seconds))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }